module.exports = __webpack_public_path__ + "27ef9645f584097524292677c8172ffb.jpg";